import { render, staticRenderFns } from "./LoadMoreAtPage.vue?vue&type=template&id=2b83aeb2&scoped=true"
import script from "./LoadMoreAtPage.vue?vue&type=script&lang=js"
export * from "./LoadMoreAtPage.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreAtPage.vue?vue&type=style&index=0&id=2b83aeb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83aeb2",
  null
  
)

export default component.exports